import { render, staticRenderFns } from "./BaseModalConfirm.vue?vue&type=template&id=50beb94c&scoped=true&"
import script from "./BaseModalConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseModalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50beb94c",
  null
  
)

export default component.exports